import { render, staticRenderFns } from "./RoleRightsSetting.vue?vue&type=template&id=e12158d6&scoped=true&"
import script from "./RoleRightsSetting.vue?vue&type=script&lang=js&"
export * from "./RoleRightsSetting.vue?vue&type=script&lang=js&"
import style0 from "./RoleRightsSetting.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "e12158d6",
  null
  
)

export default component.exports